import manageAreaTaxLocationFiltersSlice from './manageAreaTaxLocationFilters-slice';

export const {
  setActiveAreaTaxLocationFilters,
  setArchivedAreaTaxLocationFilters,
  resetActiveAreaTaxLocationFiltersState,
  resetArchivedAreaTaxLocationFiltersState,
  resetState,
} = manageAreaTaxLocationFiltersSlice.actions;

export default manageAreaTaxLocationFiltersSlice;
